import './blocks/slider';